//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      default: ''
    },
    enabled: {
      default: null
    }
  }
}
